import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isValueEntered, isNumberValid } from 'services/Validation';
import { PRODUCT_TYPES } from 'constants/lists';

export const inputFields = (data, allValueStreams, allBusinessUnits, allMembers, handleUserInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading mt-2">{<IntlMessages id="label.valueStream" />}</h3>
                <Input
                    type="select"
                    name="valueStreamId"
                    id="valueStreamSelect"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.valueStreamId}
                >
                    <option key='emptySelect' value=''>-- select value stream --</option>
                    {allValueStreams.map((valueStream) => {
                        return <option key={valueStream.id} value={valueStream.id}>{valueStream.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.businessUnit" />}</h3>
                <Input
                    type="select"
                    name="businessUnitId"
                    id="businessUnitSelect"
                    className={data?.businessUnitId ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.businessUnitId}
                >
                    <option key='emptySelect' value=''>-- select business unit --</option>
                    {allBusinessUnits.map((businessUnit) => {
                        return <option key={businessUnit.id} value={businessUnit.id}>{businessUnit.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.manager" />}</h3>
                <Input
                    type="select"
                    name="manager"
                    id="managerSelect"
                    className={data?.manager ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.manager}
                >
                    <option key='emptySelect' value=''>-- select manager --</option>
                    {allMembers.map((member) => {
                        return <option key={member.id} value={member.id}>{member.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.fyBudget" />}</h3>
                <Input id="fyBudget" type="text" className={`form-control mb-2 ${data?.fyBudget ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event, true)}
                    defaultValue={data?.fyBudget} name="fyBudget"
                />
                <h3 className="card-heading">{<IntlMessages id="label.productType" />}</h3>
                <Input
                    type="select"
                    name="productType"
                    id="productTypeSelect"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.productType}
                >
                    <option key='emptySelect' value=''>-- select product type --</option>
                    {PRODUCT_TYPES.map((productType) => {
                        return <option key={productType} value={productType}>{productType}</option>;
                    })}
                </Input>
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedProduct) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedProduct?.thumb || 'assets/images/products-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const isFormValid = (selectedProduct) => {
    return isValueEntered(selectedProduct?.name) &&
    isValueEntered(selectedProduct?.manager) &&
    isValueEntered(selectedProduct?.businessUnitId) &&
    isNumberValid(selectedProduct?.fyBudget);
};

export const getFormError = (fieldName, value) => {
    let formError = '';
    switch (fieldName) {
        case 'name':
            formError = isValueEntered(value) ? '' : ' is invalid';
            break;
        default:
            break;
    }
    return formError;
};


// WEBPACK FOOTER //
// ./components/Agile/product/productMaintenance/common.js